// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3eo9_","title":"AfterBackImages_title__1v8OW","images":"AfterBackImages_images__umzht"};